import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import axios from 'axios';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  CircularProgress,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// dialog
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// components
import Label from '../../components/label';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
import CustomSnackBar from '../../components/snackbar';
import MenuPopover from '../../components/popover/menuPopover'
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
import AdminManagerDialog from '../../sections/dialogs/adminManagerDialog';

// mock
import USERLIST from '../../_mock/user';
// api
import { getAdminManager, deleteAdminManager, approveAdminManager, suspendAdminManager } from '../../api/superadmin/adminmanager';
import { getCommonDataWithToken } from '../../api/superadmin/commonAPIs';
import { setAdminUserStateAction } from '../../appRedux/actions/adminUser';



// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'hospital', label: 'Hospital', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'adminStatus', label: 'Status', alignRight: false },
  { id: '' },
];
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function AdminManagerList() {

  const dispatch = useDispatch()
  const loggedUser = useSelector((state) => state.adminUser)
  const accounts= loggedUser.commonData.hospitals;
  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)

  const [adminManager, setAdminManager] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [isApproveButtonLoading, setIsApproveButtonLoading] = useState(false)
  const [isRejectButtonLoading, setIsRejectButtonLoading] = useState(false)

  const [selectedItem, setSelectedItem] = useState(false)
  const [selectedId, setSelectedId] = useState(false)

  const [dialogOpen, setDialogOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [action, setAction] = useState('');

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);



  const fetchData = async () => {
    setIsLoading(true)
    try {
      const { data } = await getAdminManager();
      if (data.success) {
      const res = await getCommonDataWithToken();
        dispatch(setAdminUserStateAction({
          commonData: res.data.commondata
        }))
      }
      setAdminManager(data.hospitalAdmins)
      // console.log(data);
      setIsLoading(false)
    }
    catch (e) {
      setIsLoading(false)
      // console.log({ e });
    }
  }

  // get admins list
  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    // console.log(id);
    // setIsButtonLoading(true)
    try {
      const { data } = await deleteAdminManager(id);
      setMenuOpen(null)
      setAdminManager(data.hospitalAdmins)
      // setIsButtonLoading(false)
      setSnackbarMessage({ msg: data.message, success: true });
      setSnackbarOpen(true);
    }
    catch (e) {
      // setIsButtonLoading(false)
      setSnackbarMessage({ msg: e.message, success: false });
      setSnackbarOpen(true);
    }
  }

  const handleSuspend = async (id) => {
    // console.log(id);
    // setIsButtonLoading(true)
    try {
      const { data } = await suspendAdminManager(id);
      setMenuOpen(null)
      setAdminManager(data.hospitalAdmins)
      // setIsButtonLoading(false)
      setSnackbarMessage({ msg: data.message, success: true });
      setSnackbarOpen(true);
    }
    catch (e) {
      // setIsButtonLoading(false)
      setSnackbarMessage({ msg: e.message, success: false });
      setSnackbarOpen(true);
    }
  }


  const handleOpenMenu = (event, item) => {
    // console.log(item);
    setSelectedItem(item)
    setMenuOpen(event.currentTarget);
  };

  const handleApprove = async (id, flag) => {
    setSelectedId(id)
    if (flag) setIsApproveButtonLoading(true)
    else setIsRejectButtonLoading(true)
    try {
      const { data } = await approveAdminManager(id, { approve: flag });
      setMenuOpen(false)
      setAdminManager(data.hospitalAdmins)
      if (flag) setIsApproveButtonLoading(false)
      else setIsRejectButtonLoading(false)
      setSnackbarMessage({ msg: data.message, success: true });
      setSnackbarOpen(true);
    }
    catch (e) {
      if (flag) setIsApproveButtonLoading(false)
      else setIsRejectButtonLoading(false)
      setSnackbarMessage({ msg: e.message, success: false });
      setSnackbarOpen(true);
    }
  };

  // Dialog
  const handleDialogOpen = (item, str) => {
    if (item) {
      // console.log(item);
      setSelectedItem(item)
    }
    setAction(str)
    setDialogOpen(true);
  };



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;



  return (
    <>
      <Helmet>
        <title> Admin Manager | Teller One </title>
      </Helmet>

      <Box sx={{ height: '100%' }}>
        {!isLoading ? (
          <Box >

            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
              <Typography variant="h4" gutterBottom>
                Admin Manager
              </Typography>
              {loggedUser.user.role === 'licensemanager' &&
                <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => handleDialogOpen(null, 'CREATE')}>
                  Create Admin Manager
                </Button>
              }

            </Stack>

            <Card>
              {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={USERLIST.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                    />
                    <TableBody>
                      {adminManager && adminManager.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        const { _id, firstName, lastName, email, hospitalName, city, status } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1} role="checkbox" >
                            {/* <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell> */}

                            <TableCell component="th" >
                              <Stack direction="row" alignItems="center" spacing={2}>
                                {/* <Avatar alt={name} src={avatarUrl} /> */}
                                <Typography variant="subtitle2" noWrap>
                                  {firstName} {lastName}
                                </Typography>
                              </Stack>
                            </TableCell>


                            <TableCell align="left">{email}</TableCell>
                            <TableCell align="left">{hospitalName}</TableCell>
                            <TableCell align="left">{city}</TableCell>
                            <TableCell align="left">
                              <Label color={status !== "active" ? 'error' : 'success'}>{status}</Label>
                            </TableCell>
                            {/* 
                            <TableCell align="right">
                              <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell> */}
                            <TableCell align="right">
                              {loggedUser.user.role === 'licensemanager' &&
                                <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                                  <Iconify icon={'eva:more-vertical-fill'} />
                                </IconButton>
                              }
                              {loggedUser.user.role === 'financecontroller' && status !== 'active' && status !== 'rejected' && status !== 'suspended' &&
                                <Box display='flex'>
                                  <LoadingButton loading={selectedId === _id && isApproveButtonLoading} variant="outlined" color="success" size="small" onClick={() => handleApprove(_id, true)}>
                                    Approve
                                  </LoadingButton>
                                  <LoadingButton loading={selectedId === _id && isRejectButtonLoading} variant="outlined" color="error" size="small" onClick={() => handleApprove(_id, false)}>
                                    Reject
                                  </LoadingButton>
                                </Box>}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>

                    {isNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <Paper
                              sx={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography variant="h6" paragraph>
                                Not found
                              </Typography>

                              <Typography variant="body2">
                                No results found for &nbsp;
                                <strong>&quot;{filterName}&quot;</strong>.
                                <br /> Try checking for typos or using complete words.
                              </Typography>
                            </Paper>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>

              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={adminManager?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>

          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}> <CircularProgress /> </Box>
        )}
      </Box>
      <AdminManagerDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} setAdminManager={setAdminManager} setSnackbarMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen} selectedItem={selectedItem} action={action} accounts = {accounts} />
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />
      <MenuPopover menuOpen={menuOpen} setMenuOpen={setMenuOpen} handleDialogOpen={handleDialogOpen} handleDelete={handleDelete} handleSuspend={handleSuspend} selectedItem={selectedItem} />
    </>
  );
}
